import { Injectable } from '@angular/core';
import { TimeSlot, TimeSlotAdditionalParams, TimeSlotOption, TimeSlotsApiParams } from '@checkout-v2/const';
import { Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CheckoutActions, CheckoutSelectors } from '../store';
import { StateWithCustomCheckout } from '../store/checkout-state';

@Injectable({
  providedIn: 'root',
})
export class TimeSlotsFacade {
  constructor(private store: Store<StateWithCustomCheckout>) {}

  getTimeSlotsState(): Observable<StateUtils.LoaderState<TimeSlot[]>> {
    return this.store.select(CheckoutSelectors.getTimeSlotsState);
  }

  getTimeSlotsLoading(): Observable<boolean> {
    return this.store.select(CheckoutSelectors.getTimeSlotsLoading);
  }

  getTimeSlotsError(): Observable<boolean> {
    return this.store.select(CheckoutSelectors.getTimeSlotsError);
  }

  getTimeSlotsSuccess(): Observable<boolean> {
    return this.store.select(CheckoutSelectors.getTimeSlotsSuccess);
  }

  getTimeSlots(): Observable<TimeSlot[]> {
    return this.store.select(CheckoutSelectors.getTimeSlots);
  }

  getSelectedTimeSlotId(): Observable<string | undefined> {
    return this.store.select(CheckoutSelectors.getSelectedTimeSlotId);
  }

  getSelectedTimeSlot(): Observable<TimeSlotOption | undefined> {
    return this.store.select(CheckoutSelectors.getSelectedTimeSlot);
  }

  getSelectedTimeSlotAdditionalParams(): Observable<TimeSlotAdditionalParams | undefined> {
    return this.store.select(CheckoutSelectors.getSelectedTimeSlotAdditionalParams);
  }

  selectTimeSlot(id: string, additionalParams?: TimeSlotAdditionalParams): void {
    this.store.dispatch(new CheckoutActions.SelectTimeSlotsActiveOption(id, additionalParams));
  }

  resetTimeSlot(): void {
    this.store.dispatch(new CheckoutActions.ResetTimeSlotsActiveOption());
  }

  loadTimeSlotsForCustomDate(params: TimeSlotsApiParams): void {
    this.store.dispatch(new CheckoutActions.LoadTimeSlotsForCustomDate(params));
  }

  selectCustomDate(date: string): void {
    this.store.dispatch(new CheckoutActions.SelectTimeSlotsCustomDate(date));
  }

  getSelectedCustomDate(): Observable<string | undefined> {
    return this.store.select(CheckoutSelectors.getSelectedCustomDate);
  }

  getTimeSlotsForCustomDateState(): Observable<StateUtils.LoaderState<TimeSlot[]>> {
    return this.store.select(CheckoutSelectors.getTimeSlotsForCustomDateState);
  }

  getTimeSlotsForCustomDateLoading(): Observable<boolean> {
    return this.store.select(CheckoutSelectors.getTimeSlotsForCustomDateLoading);
  }

  getTimeSlotsForCustomDateError(): Observable<boolean> {
    return this.store.select(CheckoutSelectors.getTimeSlotsForCustomDateError);
  }

  getTimeSlotsForCustomDateSuccess(): Observable<boolean> {
    return this.store.select(CheckoutSelectors.getTimeSlotsForCustomDateSuccess);
  }
}
